export default __webpack_public_path__ + "static/media/logo.bfe35add.svg";